"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.upload.choose': 'Choose file...',
    'file.upload.change': 'Change file',
    'file.upload.remove': 'Remove file',
    'file.upload.loading': 'Loading...',
    'file.upload.drop': 'Drop file here',
    'file.upload.download': 'Download file',
    'file.upload.choose_multiple': 'Choose files...',
    'file.upload.change_multiple': 'Change files',
    'file.upload.remove_all': 'Remove all files',
    'file.upload.error.size_too_large': 'File "{fileName}" is too large. Maximum file size is 2MB.',
    'file.upload.error.size_exceeded_10mb': 'File "{fileName}" is too large. Maximum file size is {maxSize}.',
    'file.upload.error.multiple_files_size_exceeded_10mb': 'The following files are too large: {fileNames}. Maximum file size is {maxSize}.',
    'file.upload.error.image_too_large': 'Image "{filename}" ({size}) is too large. Images must be under {maxSize}.',
    'file.upload.error.unsupported_type': 'Unsupported file type. Please select a supported file format.',
    'file.upload.confirm.add_to_knowledge': 'File "{fileName}" ({fileSize}) is too large for chat. Would you like to add it to the knowledge base instead?',
    'file.upload.error.total_size_exceeded': 'Adding this file would exceed the 5MB total limit. Current total: {currentSize}, trying to add: {newSize}.',
    'file.upload.error.processing_failed': 'Error processing file "{fileName}": {error}',
    'file.upload.error.upload_failed': 'Error uploading files: {error}',
    'file.upload.error.submission_failed': 'Error during chat submission: {error}',
};
